import { trainingsRoutes } from 'modules/trainings/routes/constants';

export const trainingsPaymentRoutes = {
  root: `${trainingsRoutes.authenticated}/payment`,
  payment: `${trainingsRoutes.authenticated}/payment/:id`,
  address: `${trainingsRoutes.authenticated}/payment/address/:id`,
  success: `${trainingsRoutes.authenticated}/payment/success`,
};
